import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import isEmpty from 'lodash/isEmpty'

// CKeditor
import CKEditor from "react-ckeditor-component"
import { editorReady } from '../../../utils/editor'

// Components
import Loader from '../../utils/Loader'

// State
import { userTokenUpdate } from '../../../store/actions/user'
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../../shared/vars'

class Page extends Component {
    constructor(props){
        super(props)

        this.state = {
            id: this.props.match.params.id,
            isLoading: true,
            data: null,
            error: '',
            updateLoading: false,
            updateSuccess: '',
            updateErrors: {}
        }
    }

    componentDidMount() {
        this.loadData()
    }

    loadData(){
        const { id } = this.state

        const apiEndpoint = 'pages/' + id
    
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY }
        return axios.get(REACT_APP_API_URL + apiEndpoint, { headers: AUTH_HEADER })
		.then((response) => {
            if(response.status !== 200 || (response.data.status && response.data.status !== 200)){
                this.setState({ isLoading: false, error: response.data.message })
            }else{
                this.setState({ isLoading: false, data: { ...response.data } })
            }
		})
		.catch((err) => {
            if(err.response){
                this.setState({ isLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message })
            }else{
                this.setState({ isLoading: false, error: err.message })
            }
		})
    }

    editorChange(evt){
        const newContent = evt.editor.getData()
        const newData = {
            ...this.state.data,
            content: newContent
        }

        this.setState({ data: newData })
    }

    handleSubmit(){
        const { data } = this.state
        const { user } = this.props

        this.setState({
            updateSuccess: '',
            updateErrors: {},
            updateLoading: true
        })

        const token = user.token
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token }
        return axios.post(REACT_APP_API_URL + 'pages/' + data.permalink, data, { headers: AUTH_HEADER })
		.then((response) => {
            if(response.status !== 200 || (response.data.status && response.data.status !== 200)){
                this.setState({
                    updateLoading: false,
                    updateErrors: !isEmpty(response.data.errors) ? response.data.errors : { general: response.data.message }
                })
            }else{
                this.setState({
                    updateLoading: false,
                    updateSuccess: response.data.message
                })

                this.props.userTokenUpdate('admin', response.data.token)
            }
		})
		.catch((err) => {
            if(err.response){
                this.setState({
                    updateLoading: false,
                    updateErrors: { general: err.response.data.error ? err.response.data.error : err.response.data.message }
                })
            }else{
                this.setState({
                    updateLoading: false,
                    updateErrors: { general: err.message }
                })
            }
		})
    }

    render() {
        return (
            <div>
                {/* Has error */}
                {this.state.error ? (
                    <div className="error">
                        {Object.keys(this.state.error).map(key => 
                            <span key={key}>{this.state.error[key]}</span>
                        )}
                    </div>
            
                // No error
                ) : (
                    
                    // Loading
                    this.state.isLoading ? (
                        <div className="pt2 pb2">
                            <Loader />
                        </div>
                    
                    // Show form
                    ) : (
                        <div>
                            {!isEmpty(this.state.data) ? (
                                <div>
                                    {this.state.updateSuccess && <div className="success msg_animate">{this.state.updateSuccess}</div>}
                                    <div className="form-field product-url-display">
                                        <label>Page Title:</label>
                                        {this.state.data.title}
                                    </div>

                                    {/* CKEditor */}
                                    <CKEditor
                                        scriptUrl="/ckeditor/ckeditor.js"
                                        content={this.state.data.content}
                                        config={{
                                            filebrowserImageBrowseUrl: '/image-browser',
                                            filebrowserBrowseUrl: '/file-browser',
                                            uploadUrl: REACT_APP_API_URL + `files`
                                        }}
                                        events={{
                                            'instanceReady': editorReady.bind(this),
                                            'change': this.editorChange.bind(this)
                                        }}
                                    />

                                    <div className="btn_container">
                                        {this.state.updateErrors.general &&
                                            <div className="error msg_animate">{this.state.updateErrors.general}</div>
                                        }
                                        <button className={'btn submit-btn' + (this.state.updateLoading ? ' loading' : '')} name="submit" onClick={() => this.handleSubmit()} disabled={this.state.updateLoading}><span>Submit</span></button>
                                    </div>
                                </div>
                            ) : (
                                <div>Unable to find the page you were looking for.</div>
                            )}
                        </div>
                    )
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
	return {
		user: state.user.admin
	}
}

export default connect(mapStateToProps, { userTokenUpdate })(Page)



// WEBPACK FOOTER //
// ./src/components/admin/pages/Page.js